import { CropTypesEnum } from '@protector/utils/constants';
import type { Crop } from '@protector/utils/types';

const WHEAT_CROPS = new Set<string>([CropTypesEnum.WINTER_WHEAT, CropTypesEnum.HARD_WHEAT, CropTypesEnum.WHEAT]);
const BARLEY_CROPS = new Set<string>([CropTypesEnum.WINTER_BARLEY, CropTypesEnum.BARLEY]);
const BARLEY_CROPS_WITH_SPRING = new Set<string>([...BARLEY_CROPS, CropTypesEnum.SPRING_BARLEY]);

/** The catalogue answers slugs in mixed shapes, so they are compared snake-cased and lowercased. */
function toCropType(crop: Pick<Crop, 'wk_slug'> | undefined | null): string {
  return crop?.wk_slug?.toLocaleLowerCase().replace(/[\s-]+/g, '_') ?? '';
}

export function isAnyWheatCrop(crop: Pick<Crop, 'wk_slug'> | undefined | null): boolean {
  return WHEAT_CROPS.has(toCropType(crop));
}

/**
 * Spring barley is opt-in: the disease-risk flows deliberately leave it out, since the risk model
 * only covers the winter crops.
 */
export function isAnyBarleyCrop(crop: Pick<Crop, 'wk_slug'> | undefined | null, shouldIncludeSpringBarley = false): boolean {
  const accepted = shouldIncludeSpringBarley ? BARLEY_CROPS_WITH_SPRING : BARLEY_CROPS;

  return accepted.has(toCropType(crop));
}

export function isGrapeCrop(crop: Pick<Crop, 'wk_slug'> | undefined | null): boolean {
  return toCropType(crop) === CropTypesEnum.GRAPE;
}

export function isPotatoCrop(crop: Pick<Crop, 'wk_slug'> | undefined | null): boolean {
  return toCropType(crop) === CropTypesEnum.POTATO;
}
